/**
 * Antwortmöglichkeiten von CC-Aufgaben.
 * Bindet die Inputs ng-model an das scope von v3sExercise über 'require' und Einbindung des Controllers
 * 
 * @class directive_v3sCcAnswer
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').directive('v3sCcAnswer', ['$document','$tooltip', '$compile','v3sExerciseService', function ($document, $tooltip, $compile, v3sExerciseService) {
    return {
        restrict: 'E',
        require: ['^v3sExercise', '^v3sDocument'],
        scope: {
            'id': '@'
        },
        link: function (scope, element, attrs, controllers) {
            var exCtrl = controllers[0];
            var docCtrl = controllers[1];

            if (!!scope.id) {
                docCtrl.addElement(element);
            }

            scope.getVar = docCtrl.getVar;

            var answerCorrect = element.find('v3s-correct').html();
            var fod = element.find('v3s-fod').html();
            var data = element.find('v3s-data').html();

            scope.decisionSettings = exCtrl.decisionSettings;

            //FOD muss auch hier angezeigt werden
            var tooltip;
            v3sExerciseService.subscribeExerciseChanged(scope, function () {
                if (v3sExerciseService.isCompleted()) {
                    var el = angular.element(element[0].querySelector('.cc-answer'));
                    tooltip = $tooltip(el, { title: fod, container: "v3s-document", viewport: '#page-view', placement: 'top auto', trigger: 'hover focus' });
                }
            });

            var isCorrect, templateString = '';
            templateString += '<v3s-sc-answer-group  v3s-left="' + parseInt(exCtrl.decisionSettings.left) + '">';
            angular.forEach(scope.decisionSettings.decisions, function (d, i) {
                isCorrect = (d.id == answerCorrect) ? 1 : 0;
                templateString += '<v3s-sc-answer id="' + scope.id + '_' + i + '" style="position: relative;" v3s-width="' + exCtrl.decisionSettings.spacing
                    + '" v3s-left="' + exCtrl.decisionSettings.left + '" ><v3s-correct>' + isCorrect + '</v3s-correct><v3s-fod>' + fod
                    + '</v3s-fod><v3s-data></v3s-data></v3s-sc-answer>';
            });
            templateString += '</v3s-sc-answer-group>';

            /**
             * Damit die Data-Elemente auf der richtigen Position angezeigt werden
             * müssen sie absolute im v3s-document positioniert werden
             * 
             * Außerdem wird ihnen über die Klasse cc-answer ein padding verpasst
             *
             * Da angular.element.find() nicht nach ids suchen kann, ist der beste weg: parent().parent()
             * um an v3s-document zu kommen
             */

            /**
             * Die angegebene Breite wird hier als in das style attribute des v3s-data elements geschrieben
             * 
             * TODO: Saubere Lösung für die Breitenangabe finden und umsetzen
             */
            var dataWidth = (!!attrs.v3sWidth) ? attrs.v3sWidth + "px" : "auto";
            var dataString = '<v3s-data class="cc-answer" v3s-left="' + attrs.v3sLeft + '" style="position:absolute;width:' + dataWidth + '">' + data + '</v3s-data>';
            templateString += dataString;
            element.html(templateString);
            $compile(element.children())(scope);
            element.css('left', 0);
            element.css("width", '100%');
        }
    };
}]);
